import { render, staticRenderFns } from "./AccountBind.vue?vue&type=template&id=af993328&scoped=true&"
import script from "./AccountBind.vue?vue&type=script&lang=js&"
export * from "./AccountBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af993328",
  null
  
)

export default component.exports